import type { FC } from 'react';
import {
  useGetLegalEntities,
  useGetPaymentProcessor,
} from '@pflegenavi/frontend/api-nursing-home';
import { useIsGlobalTenantAdmin } from '@pflegenavi/frontend/nursing-home-context';
import { useTenantFeatureFlagEnabled } from '@pflegenavi/frontend/feature-flags';
import { FeatureFlag } from '@pflegenavi/shared/api';
import { useKycIdvDialogState } from '@pflegenavi/web-components';
import { getLegalEntityKycWarnings } from './legalEntityKycWarnings';
import { LegalEntityKycBannerView } from './LegalEntityKycBannerView';
import { LegalEntityKycIdvDialog } from './LegalEntityKycIdvDialog';

/** Global tenant admins verify and renew the KYC of the tenant's legal entities. */
export const LegalEntityKycBanner: FC = () => {
  const isGlobalTenantAdmin = useIsGlobalTenantAdmin();
  const paymentProcessor = useGetPaymentProcessor();
  const hostedIdvEnabled = useTenantFeatureFlagEnabled(
    FeatureFlag.dev_LegalEntityHostedIdv
  );

  if (
    !isGlobalTenantAdmin ||
    paymentProcessor !== 'mangopay' ||
    !hostedIdvEnabled
  ) {
    return null;
  }
  return <LegalEntityKycBannerContainer />;
};

const LegalEntityKycBannerContainer: FC = () => {
  const { data: legalEntities } = useGetLegalEntities();
  const { openFor, openDialog, closeDialog, returnUrlFor } =
    useKycIdvDialogState<string>();

  const warnings = getLegalEntityKycWarnings(
    legalEntities?.data ?? [],
    new Date()
  );
  const dialogLegalEntity = legalEntities?.data.find(
    (legalEntity) => legalEntity.id === openFor
  );

  return (
    <>
      <LegalEntityKycBannerView warnings={warnings} onOpenDialog={openDialog} />
      {dialogLegalEntity && (
        <LegalEntityKycIdvDialog
          legalEntity={dialogLegalEntity}
          open
          onClose={closeDialog}
          returnUrl={returnUrlFor(dialogLegalEntity.id)}
        />
      )}
    </>
  );
};
